import { render, staticRenderFns } from "./ShowNewsPanel.vue?vue&type=template&id=79538f1e&"
import script from "./ShowNewsPanel.vue?vue&type=script&lang=js&"
export * from "./ShowNewsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports